import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { nextPage } from '../../functions/nextPage';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import * as webAppointmentConstants from '../../constants/webAppointmentConstants';

export class PfaAppointmentPage extends Component {
  constructor(props) {
    super(props);
    this.state = { popup: null };
  }

  displayWindow = () => {
    let popup;
    // this.state.windowObj will be defined in the jest test code, so that we can
    // verify that .open() gets called on the right button push (or whatever event).
    // The standard window.open() function that’s available in a browser isn’t
    // implemented for test code.
    if (this.state["windowObj"] !== undefined) {
      popup = this.state.windowObj.open(webAppointmentConstants.myChartPfaScheduleUrl, '', 'width=780,height=620');
    }
    else {
      popup = window.open(webAppointmentConstants.myChartPfaScheduleUrl, '', 'width=780,height=620');
    }
    this.setState({ popup });
    setTimeout(this.checkWindow, 500);
  }

  checkWindow = () => {
    if (this.state.popup && this.state.popup.closed) {
      this.props.webAppointmentPfaCallbackWindowDismissed(true);
      this.setState({ popup: null });
    }
    else {
      setTimeout(this.checkWindow, 500);
    }
  }

  componentDidMount() {
    this.props.webAppointmentPfaCallbackWindowDismissed(false);
  }

  render() {
    const title = "For faster scheduling, choose a callback time.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          !this.props.pfaCallbackWindowDismissed ?
          {
            type: 'button',
            id: "schedule-callback",
            className: "btn--primary",
            value: 'Schedule Callback',
            onClick: () => {
              this.displayWindow();
            }
          } : null,
          !this.props.pfaCallbackWindowDismissed ?
          {
            type: 'button',
            id: "skip-and-finish",
            className: "btn--tertiary",
            value: 'Skip and finish',
            onClick: () => {
              this.props.history.push(nextPage());
            }
          } : null,
          this.props.pfaCallbackWindowDismissed ?
          {
            type: 'button',
            id: "finish",
            className: "btn--primary",
            value: 'Finish',
            onClick: () => {
              this.props.history.push(nextPage());
            }
          } : null
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
            <p>For your convenience, schedule a time to receive a callback from a patient financial advocate (PFA) to complete your appointment request. Times may be available as soon as today. (A pop-up window will open to schedule your callback.)</p>
            <p>Or, you can reach us by calling <a href="tel:8558311284">855.831.1284</a>, Monday - Friday, 8 a.m. - 6 p.m.</p>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

PfaAppointmentPage.propTypes = {
  pfaCallbackWindowDismissed: PropTypes.bool,
  webAppointmentPfaCallbackWindowDismissed: PropTypes.func.isRequired,
  webAppointmentSetRequestResults: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    pfaCallbackWindowDismissed: state.webAppointmentForm.pfaCallbackWindowDismissed
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentPfaCallbackWindowDismissed: (value) => dispatch(webAppointmentActions.webAppointmentPfaCallbackWindowDismissed(value)),
    webAppointmentSetRequestResults: (value) => dispatch(webAppointmentActions.webAppointmentSetRequestResults(value))
  };
};

// connects component to redux, and passes along the router
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PfaAppointmentPage));
